const Message = ({ text }) => {
  return (
    <div className="w-full text-[#475b78] flex justify-center items-center text-xs font-medium leading-4 mt-[40vh]">
      {text}
    </div>
  );
};

export default Message;
